import { connect } from 'react-redux';
import ChooseDocumentType from './chooseDocumentType/ChooseDocumentType';
import DocumentUploader from './documentUploader/DocumentUploader';
import { RootState } from '@iwProvider/configureStore';
import {
    SHOW_UPLOAD_DOCUMENTS_MODAL,
    UPLOAD_DOCUMENT
} from './UploadDocumentsModal.actions';
import { CLOSE_MODAL } from '@iwModals/Modals.actions';
import { Dispatch } from 'redux';

const mapStateToProps = ({ uploadDocumentsModal }: RootState) =>
    uploadDocumentsModal;

const mapDispatchToProps = (dispatch: Dispatch) => ({
    closeModal: () => dispatch({ type: CLOSE_MODAL }),
    goBackToDocumentTypeSelection: () =>
        dispatch({ type: SHOW_UPLOAD_DOCUMENTS_MODAL }),
    uploadDocument: (
        documents: File[],
        documentType: {
            label: string;
            value: string;
        }
    ) => dispatch({ type: UPLOAD_DOCUMENT, documents, documentType })
});

type PropsFromRedux = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps>;

const UploadDocumentsModal = (props: PropsFromRedux) => {
    const {
        documentType,
        documentTypes,
        goBackToDocumentTypeSelection,
        closeModal,
        uploadDocument,
        documentsStatus,
        preventBackNavigation
    } = props;

    if (!documentType) {
        return <ChooseDocumentType documentTypes={documentTypes!} />;
    }

    return (
        <DocumentUploader
            closeModal={closeModal}
            goBackToDocumentTypeSelection={goBackToDocumentTypeSelection}
            uploadDocument={uploadDocument}
            documentsStatus={documentsStatus}
            documentType={documentType}
            preventBackNavigation={preventBackNavigation}
        />
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UploadDocumentsModal);
